// Normaliza teléfonos españoles para comparar ANDI con los formularios largos.
export const phoneKey = (value: unknown): string => {
  let digits = String(value ?? "").replace(/\D/g, "");
  digits = digits.replace(/^00/, "");
  if (digits.length > 9 && digits.startsWith("34")) digits = digits.slice(2);
  return digits;
};

// Los índices de cofidisCases distinguen teléfono fijo/móvil y conservan el
// prefijo internacional. Se consultan las cuatro posibilidades y después se
// valida el número completo para no enlazar un formulario por un mero prefijo.
export const cofidisPhoneSearchTokens = (key: string): string[] => {
  if (key.length < 3) return [];
  const variants = [key, `34${key}`];
  return Array.from(new Set(
    variants.flatMap((phone) => [
      `mobile:${phone.slice(0, 10)}`,
      `phone:${phone.slice(0, 10)}`,
    ])
  ));
};

// Compatibilidad con formularios antiguos cuyo móvil conserva espacios (a
// veces incluso un espacio final) y todavía no puede resolverse por índice.
// Firestore acepta estas variantes juntas en una consulta `in` acotada.
export const cofidisPhoneExactVariants = (key: string): string[] => {
  if (key.length !== 9) return [key];
  const grouped2 = `${key.slice(0, 3)} ${key.slice(3, 5)} ${key.slice(5, 7)} ${key.slice(7)}`;
  const grouped3 = `${key.slice(0, 3)} ${key.slice(3, 6)} ${key.slice(6)}`;
  return Array.from(new Set([
    key,
    `${key} `,
    `34${key}`,
    `+34${key}`,
    grouped2,
    `${grouped2} `,
    grouped3,
    `${grouped3} `,
    `34 ${grouped2}`,
    `34 ${grouped2} `,
    `+34 ${grouped2}`,
    `+34 ${grouped2} `,
    `34 ${grouped3}`,
    `+34 ${grouped3}`,
  ]));
};

export const cofidisCaseHasPhone = (data: any, key: string): boolean => {
  const first = data?.primerTitular || {};
  const second = data?.segundoTitular || {};
  const candidates = [
    first.movil,
    first.telefonoFijo,
    first.phone,
    second.movil,
    second.telefonoFijo,
    second.phone,
    data?.phone,
    data?.secondaryPhone,
    data?.mobile,
    data?.movil,
  ];
  return candidates.some((candidate) => phoneKey(candidate) === key);
};

export const cofidisCaseHasCompletedSignature = (data: any): boolean => {
  const flags = data?.firmas?.applicationSignature || {};
  const hasSecondHolder = !!data?.segundoTitular?.nombre;
  return !!flags.primerTitular && (!hasSecondHolder || !!flags.segundoTitular);
};
